<template>
  <div class="content-main">
    <b-alert v-for="r in expiryReminders" :key="'exp'+r.id" show variant="warning" class="mb-3">{{ expiryReminderText(r) }}</b-alert>
    <h6 class="title-section">{{ $t("horario.breadcrumb.titulo") }}</h6>
    <div v-show="flagPageLoaded" class="container-loading">
      <b-spinner :label="$t('reusables.loading')"></b-spinner>
    </div>
    <div class="card" v-show="!flagPageLoaded">
      <div class="card-body">
        <div v-if="!flagScheduleAvailability && !flagScheduleStudents">
          <!-- <h6 class="sub-title text-left mb-3">
                  <span class="text-center mb-3">{{$t('horario.breadcrumb.text.1')}}</span>
                  <span class="text-center mb-3">{{$t('horario.breadcrumb.text.2')}} <br> {{$t('horario.breadcrumb.text.2-2')}}</span>
                  <span class="text-center mb-2 text-danger">{{$t('horario.breadcrumb.text.3')}}</span>
                </h6> -->
          <h6 class="sub-title text-left mb-3">
            <span class="text-center mb-3">{{
              $t("horario.breadcrumb.text.1")
            }}</span>
          </h6>
          <p class="text-center" style="font-size: 15px">
            {{ $t("horario.breadcrumb.text.2") }} <br />
            {{ $t("horario.breadcrumb.text.2-2") }}
          </p>
        </div>
        <div v-if="flagScheduleAvailability && nextClass == null && !flagNoCurrentSchedule">
          <h6 class="sub-title text-left mb-3">
            <span
              class="text-center mb-3 d-flex align-items-center justify-content-center"
              >Explore
              <a href="/teacher/class-request" class="link mt-3 pr-2 pl-2"
                ><span> student requests</span></a
              >
              and get your first student.</span
            >
          </h6>
        </div>
        <template
          v-if="flagScheduleAvailability && flagScheduleStudents && nextClass"
        >
          <div class="row">
            <div class="col">
              <div class="card card-next-class">
                <div class="left">
                  <b-avatar
                    variant="light"
                    :src="
                      nextClass.classPhoto ? nextClass.classPhoto : urlPhoto
                    "
                    size="6rem"
                    class="mr-4"
                  ></b-avatar>
                  <div class="time mr-2">
                    <h6>{{ $t("horario.next-class.nextClass") }}</h6>
                    <p class="bold">{{ nextClass.className }}</p>
                    <span>{{ nextClass.strStartDate_EN }}</span>
                    <span>{{ nextClass.strStartEndDate }}</span>
                  </div>
                </div>
                <button
                  type="button"
                  @click="
                    openLinkClassLocal(
                      nextClass.linkClass,
                      $moment,
                      nextClass.startDate,
                      nextClass.endDate
                    )
                  "
                  class="btn btn-primary"
                  :class="
                    nextClass && nextClass.linkClass != null ? '' : 'disabled'
                  "
                >
                  <icon name="video" />
                  {{ $t("horario.next-class.join") }}
                </button>
              </div>
            </div>
            <div class="col" style="display: flex">
              <h6 class="sub-title mb-0 align-self-center">
                <span class="text-center"
                  >If you must cancel a class, click on the class and select
                  “Cancel class”.
                </span>
              </h6>
            </div>
          </div>
        </template>
        <div>
          <div class="d-flex justify-content-between mt-4 mb-4 filter-center">
            <span
              v-if="!flagScheduleAvailability && !flagScheduleStudents"
              style="font-size: 15px"
              class="bold text-danger"
              >{{ $t("horario.breadcrumb.text.3") }}</span
            >

            <CustomSelect
              :style="{
                display:
                  flagScheduleAvailability &&
                  flagScheduleStudents &&
                  Boolean(listStudents.length)
                    ? 'flex'
                    : 'none',
                width:
                  !flagScheduleAvailability && !flagScheduleStudents
                    ? '200px'
                    : '320px',
              }"
              @input="idValueSelectClassNameSelected"
              :options="listStudents"
              value="id"
              label="descripcion"
              :default="$t('calendar-teacher.filter')"
              :defaultValue="0"
              @change="GetClass(classNameSelected)"
            />

            <div
              class="align-items-center ml-auto"
              style="display: contents"
              v-if="
                (flagScheduleAvailability && flagEditSchedule) ||
                (!flagScheduleAvailability && flagEditSchedule)
              "
            >
              <span
                v-if="
                  (flagScheduleAvailability && flagEditSchedule) ||
                  (!flagScheduleAvailability && flagEditSchedule)
                "
                style="font-size: 15px"
                class="bold text-danger"
                >Please update your UNAVAILABLE hours.</span
              >

              <div class="d-flex align-items-center ml-auto">
                <b-button
                  variant="danger"
                  class="btn-danger d-flex mr-2"
                  @click="cancelEditSchedule"
                  v-if="flagScheduleAvailability && flagEditSchedule"
                  :disabled="showLoadingCalendar"
                >
                  {{ $t("horario.next-class.cancel") }}
                </b-button>
                <b-button
                  variant="primary"
                  class="btn-primary d-flex mr-2"
                  @click="saveScheduleUnavailability"
                  :class="{ loading: isLoading }"
                  v-if="!flagScheduleAvailability || flagEditSchedule"
                  :disabled="showLoadingCalendar"
                >
                  {{ $t("horario.next-class.save") }}
                </b-button>
              </div>
            </div>

            <div
              class="d-flex align-items-center ml-auto"
              v-if="flagScheduleAvailability && !flagEditSchedule"
            >
              <b-button
                variant="primary"
                class="btn-primary d-flex m-auto mr-2"
                @click="toggleEditScheduleUnavailability(true)"
                :disabled="showLoadingCalendar"
              >
                {{ $t("schedule.button") }}
              </b-button>
            </div>
          </div>
        </div>

        <div v-show="showLoadingCalendar" class="container-loading">
          <b-spinner :label="$t('reusables.loading')"></b-spinner>
        </div>
        <div v-show="!showLoadingCalendar">
          <FullCalendar
            :options="calendarOptions"
            class="demo-app-calendar"
            ref="fullCalendar"
          >
            <template v-slot:eventContent="arg">
              <div
                class="fc-event-main-frame"
                :class="
                  !flagEditSchedule && arg.event.extendedProps.scheduleId != 0
                    ? 'cursor-pointer'
                    : ''
                "
                @click="getDataClass(arg.event)"
              >
                <span
                  v-show="arg.event.startEditable"
                  @click="removeEvent(arg.event)"
                  class="material-icons"
                  >clear</span
                >
                <!-- arg.event.startEditable -->
                <span
                  v-show="
                    arg.event.extendedProps.typeOfSchedule ==
                      TYPE_SCHEDULE.STUDENT &&
                    arg.event.extendedProps.linkClass == null &&
                    !arrStatusNotEditableLinkClass.includes(
                      arg.event.extendedProps.stateClass.value
                    )
                  "
                  class="material-icons"
                  style="color: red"
                  >priority_high</span
                >

                <div class="fc-event-time">{{ arg.timeText }}</div>
                <div class="fc-event-title-container">
                  {{ arg.event.title }}
                </div>
              </div>
            </template>
          </FullCalendar>
        </div>

        <!--MODAL RECHAZAR MODIFICACIÓN DE HORARIO-->
        <b-modal
          id="reject-student-schedule"
          :centered="true"
          body-class="pt-2"
          footer-class="justify-content-center"
        >
          <template #modal-header="{ close }">
            <img
              class="close"
              src="@/assets/img/close_red.png"
              @click="close()"
            />
          </template>
          <p class="text-center">
            Do you want to reject the student's modified schedule?
          </p>
          <b-form-textarea
            id="textarea"
            placeholder="Please enter the motive..."
            rows="4"
            no-resize
          ></b-form-textarea>
          <template #modal-footer>
            <div class="w-100 d-flex justify-content-center">
              <b-button
                variant="danger"
                @click="$bvModal.hide('reject-student-schedule')"
                >Cancel</b-button
              >
              <b-button class="ml-2" variant="primary">
                <template>Reject it</template>
                <!-- <b-spinner
                    style="width: 1rem !important; height: 1rem !important"
                    v-else
                    variant="light"
                    label="Spinning"
                  ></b-spinner> -->
              </b-button>
            </div>
          </template>
        </b-modal>
        <!-- ------- -->

        <!--MODAL CON INFORMACION DE LA CLASE-->
        <b-modal
          id="modal-class-info"
          centered
          @close="closeModalClassInfo"
          :hide-footer="
            !(
              infoClass.stateClass &&
              !arrStatusNotEditableLinkClass.includes(
                infoClass.stateClass.value
              )
            )
          "
          @hide="handleHideModal"
        >
          <template #modal-header="{ close }">
            <img
              class="close"
              src="@/assets/img/close_red.png"
              @click="close()"
            />
            <h5>{{ $t("horario.modal-notes.text-4") }}</h5>
          </template>
          <p
            class="d-flex align-items-center"
            v-if="infoClass.stateClass != null"
          >
            <i class="material-icons-outlined mr-3">query_stats</i>
            <span
              style="font-weight: 600"
              :style="{ color: infoClass.color }"
              >{{
                horarioObtenerNameClaseENConsolidado(
                  infoClass.stateClass.strValue
                )
              }}</span
            >
          </p>
          <p class="d-flex align-items-center">
            <i class="material-icons-outlined mr-3">account_circle</i>
            <span>{{ infoClass.className }}</span>
          </p>
          <p class="d-flex align-items-center">
            <i class="material-icons-outlined mr-3">schedule</i>
            <span>{{
              infoClass != null
                ? getFormatDateComplete(
                    infoClass.startDate,
                    infoClass.endDate,
                    this.lang,
                    infoClass.flagPlanTest,
                    1
                  )
                : ""
            }}</span>
          </p>
          <p v-if="infoClass.flagPlanTest" class="d-flex align-items-center">
            <i class="material-icons-outlined mr-3">quiz</i>
            <span>{{ $t("reusables.test-class") }}</span>
          </p>
          <p class="d-flex align-items-center">
            <i class="material-icons-outlined mr-3">class</i>
            <span style="white-space: pre-line">{{
              infoClass.subjectsName
            }}</span>
          </p>
          <div
            class="d-flex align-items-center"
            v-if="
              (!infoClass.flagPlanTest &&
                infoClass.stateClass &&
                !arrStatusNotEditableLinkClass.includes(
                  infoClass.stateClass.value
                )) ||
              linkClass
            "
          >
            <i class="material-icons-outlined mr-3">link</i>
            <b-form-input
              required
              v-if="flagEditLink"
              :placeholder="$t('horario.modal-notes.join-class')"
              v-model.trim="dataClass.linkClass"
              v-bind:class="{ error: $v.dataClass.linkClass.$error }"
              @blur="$v.dataClass.linkClass.$touch()"
            >
            </b-form-input>
            <span style="word-break: break-all" v-else>{{ linkClass }}</span>
          </div>
          <div v-else>
            <i class="material-icons-outlined mr-3">link</i>
            <span style="word-break: break-all">{{
              linkClass ? linkClass : "-"
            }}</span>
          </div>
          <span
            v-if="
              (infoClass.stateClass &&
                !arrStatusNotEditableLinkClass.includes(
                  infoClass.stateClass.value
                )) ||
              linkClass
            "
            class="error-input"
            >{{ validationURLClass($v.dataClass.linkClass) }}</span
          >

          <div
            class="text-right"
            v-if="
              !infoClass.flagPlanTest &&
              infoClass.stateClass &&
              !arrStatusNotEditableLinkClass.includes(
                infoClass.stateClass.value
              )
            "
          >
            <b-link
              class="ml-2"
              style="font-size: 12px; color: #d1263a"
              v-show="flagEditLink && linkClass"
              @click="toggleFlagEdit(false)"
              >{{ $t("reusables.cancel") }}</b-link
            >
            <b-link
              class="ml-2"
              style="font-size: 12px"
              v-show="flagEditLink"
              @click="saveLinkClass(infoClass.scheduleId)"
              >{{ $t("reusables.save") }}</b-link
            >
            <b-link
              class="ml-2"
              style="font-size: 12px; color: #d1263a"
              v-show="!flagEditLink && dataClass.linkClass"
              @click="deleteLinkClass(infoClass.scheduleId)"
              >{{ $t("reusables.delete") }}</b-link
            >
            <b-link
              class="ml-2"
              style="font-size: 12px"
              v-show="!flagEditLink"
              @click="toggleFlagEdit(true)"
              >{{ $t("reusables.edit") }}</b-link
            >
          </div>
          <div>
            <b-alert
              show
              variant="danger"
              style="padding: 5px; font-size: 0.7rem; text-align: center"
              v-if="showAlertModal"
            >
              {{ message }}
            </b-alert>
          </div>
          <b-alert show variant="danger" class="mt-3" v-if="messageResult">{{
            messageResult
          }}</b-alert>
          <template
            #modal-footer
            v-if="
              infoClass.stateClass &&
              !arrStatusNotEditableLinkClass.includes(
                infoClass.stateClass.value
              )
            "
          >
            <!--<b-button variant="link" @click="closeModal"> {{$t('horario.buttons.cancel')}} </b-button>-->
            <b-button v-b-modal.modal-schedule-cancel-teacher variant="danger">
              <div
                style="display: flex; align-items: center"
                v-if="!showSpinnerSave"
              >
                <span style="color: #ffffff">{{
                  $t("horario.buttons.cancel-classes")
                }}</span>
              </div>
              <b-spinner
                style="width: 1rem !important; height: 1rem !important"
                v-else
                variant="light"
                label="Spinning"
              ></b-spinner>
            </b-button>
            <button
              type="button"
              class="btn btn-primary"
              @click="viewClass(linkClass)"
              :disabled="flagEditLink"
            >
              <icon name="video" />
              {{ $t("horario.modal-notes.button-enter-zoom") }}
            </button>
          </template>
        </b-modal>
      </div>
    </div>
    <b-toast
      id="toast-equis-modal-calendar-class"
      variant="none"
      no-close-button
      toaster="b-toaster-top-center"
    >
      <img
        src="@/assets/img/ico-equis.png"
        style="margin-right: 10px; margin-top: -2px"
      />
      {{ message }}
    </b-toast>
    <div>
      <b-modal
        id="modal-schedule-cancel-teacher"
        :centered="true"
        :no-close-on-esc="true"
      >
        <template #modal-header="{ close }">
          <img
            class="close"
            src="@/assets/img/close_red.png"
            @click="close()"
          />
          <p class="text-center">
            Do you really want to cancel this class? Please, only do so if it is
            absolutely necessary.
          </p>
        </template>

        <template #modal-footer>
          <b-button
            variant="danger"
            @click="$bvModal.hide('modal-schedule-cancel-teacher')"
            >{{
              $t("modals.modalViewSchedule.modal-schedule-cancel.button-cancel")
            }}</b-button
          >
          <b-button
            @click="cancelClass(infoClass.scheduleId)"
            variant="primary"
          >
            <template v-if="!showSpinnerCancel">{{
              $t("modals.modalViewSchedule.modal-schedule-cancel.button")
            }}</template>
            <b-spinner
              style="width: 1rem !important; height: 1rem !important"
              v-else
              variant="light"
              label="Spinning"
            ></b-spinner>
          </b-button>
        </template>
      </b-modal>
      <b-modal id="modal-next-linkClass" :centered="true">
        <template #modal-header="{ close }">
          <img
            class="close"
            src="@/assets/img/close_red.png"
            @click="close()"
          />
        </template>
        <p class="text-center mb-0">{{ messageLinkClassResult }}</p>
        <template #modal-footer>
          <b-button
            @click="$bvModal.hide('modal-next-linkClass')"
            variant="primary"
            >Aceptar</b-button
          >
        </template>
      </b-modal>
    </div>
    <modalChangeTimeZone
      @updateCalendar="getScheduleAvailabilityConfigured()"
    />
    <modalExpiryReminder ref="modalExpiry"/>
  </div>
</template>
<script>
import CustomSelect from "@/components/form/select";
import "@fullcalendar/core/vdom"; // solves problem with Vite
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import {
  horarioObtenerColorClaseConsolidado,
  getFormatDateComplete,
  getCalendarHeaderFormat,
  getCalendarTitle,
  getCalendarEventTimeFormat,
  getCalendarHeaderToolbar,
  openLinkClass,
  getHoursByTimeZoneName,
  getNextClassDate,
  getNextClassTime,
  convertTimeToUserTimeFormat,
  horarioObtenerNameClaseENConsolidado,
  ValidarMergeHorarios,
} from "@/assets/js/util.js";
import { baseInstanceAxios } from "@/assets/js/axiosBase.js";
import * as Constants from "@/assets/js/appConstants";
import { required, url } from "vuelidate/lib/validators";
import { validationMessage } from "vuelidate-messages";
import modalChangeTimeZone from "@/components/modals/ModalChangeTimeZone";
import modalExpiryReminder from "@/components/modals/modal-expiry-reminder";

const formLinkClass = {
  required: function () {
    return this.$t("error.3");
    // return 'Debe ingresar una URL';
  },
  url: function () {
    return this.$t("error.4");
    // return 'Debe ingresar una URL válida'
  },
};

let eventGuid = 0;
let _self;
export function createEventId() {
  return String(eventGuid++);
}

export default {
  components: {
    FullCalendar, // make the <FullCalendar> tag available
    CustomSelect,
    modalChangeTimeZone,
    modalExpiryReminder,
  },
  data() {
    return {
      expiryReminders: [], 
      urlPhoto: Constants.IMAGENES.PHOTO_TEACHER_DEFAULT,
      horarioObtenerNameClaseENConsolidado:
        horarioObtenerNameClaseENConsolidado,
      messageResult: null,
      messageLinkClassResult: null,
      dateStartValidate: null,
      dateEndValidate: null,
      showSpinnerCancel: false,
      lang: localStorage.getItem("lang"),
      classNameSelected: 0,
      flagScheduleAvailability: false,
      flagScheduleStudents: false,
      flagEditSchedule: false,
      editScheduleDate: null,
      isLoading: false,
      listStudents: [],
      baseSchedule: [],
      nextClass: null,
      infoClass: {},
      message: "",
      dataClass: { linkClass: "" },
      linkClass: "",
      flagEditLink: false,
      showLoadingCalendar: true,
      arrStatusNotEditableLinkClass: [
        Constants.CALENDAR_STATUS.COMPLETED.VALUE,
        Constants.CALENDAR_STATUS.CANCELED_TEACHER.VALUE,
        Constants.CALENDAR_STATUS.CANCELED_STUDENT.VALUE,
        Constants.CALENDAR_STATUS.PENDING_REPORT.VALUE,
        Constants.CALENDAR_STATUS.UNATTENDANCE_STUDENT.VALUE,
        Constants.CALENDAR_STATUS.UNATTENDANCE_TEACHER.VALUE,
        Constants.CALENDAR_STATUS.FROZEN.VALUE,
      ],
      formatDay: "DD",
      //headerToolbar: getCalendarHeaderToolbar(),
      calendarOptions: {
        plugins: [
          dayGridPlugin,
          timeGridPlugin,
          interactionPlugin, // needed for dateClick
        ],
        //initialDate: new Date(),
        events: [],
        eventOverlap: false,
        themeSystem: "bootstrap",
        firstDay: 1,
        //gotoDate: new Date('2018-06-01'),
        customButtons: {
          today: {
            text: "TODAY",
            click: () => {
              let date = new Date();

              let dateFormat = `${date.getFullYear()}-${
                date.getMonth() + 1
              }-${date.getDate()}T00:00:00`;
              if (_self.flagEditSchedule) {
                _self.updateScheduleAvailability(dateFormat, date);
              } else {
                _self.updateSchedule(dateFormat, null);
              }
            },
          },
          prev: {
            click: function () {
              if (_self.flagEditSchedule) {
                // currentRange.end is the (exclusive) end of the visible week, so
                // subtracting 7 days from it lands back on the SAME week's start, not
                // the previous week -- use currentRange.start instead for prev.
                let rangeStart =
                  _self.$refs.fullCalendar.getApi().currentData.dateProfile
                    .currentRange.start;
                let prevDate = new Date(
                  rangeStart.getFullYear(),
                  rangeStart.getMonth(),
                  rangeStart.getDate()
                );
                prevDate.setDate(prevDate.getDate() - 7);
                let prevDateFormat = `${prevDate.getFullYear()}-${
                  prevDate.getMonth() + 1
                }-${prevDate.getDate()}T00:00:00`;
                _self.updateScheduleAvailability(prevDateFormat, prevDate);
                return;
              }

              let dataDate =
                _self.$refs.fullCalendar.getApi().currentData.dateProfile
                  .currentRange.end;
              let date = new Date(
                dataDate.getFullYear(),
                dataDate.getMonth(),
                dataDate.getDate()
              );
              date.setDate(date.getDate() - 7);
              let dateFormat = `${date.getFullYear()}-${
                date.getMonth() + 1
              }-${date.getDate()}T00:00:00`;

              _self.updateSchedule(dateFormat, false);
            },
          },
          next: {
            click: function () {
              if (_self.flagEditSchedule) {
                // currentRange.end is already the start of the NEXT week, so adding
                // another 7 days here would skip a week -- use currentRange.start + 7
                // instead, mirroring the prev fix above.
                let rangeStart =
                  _self.$refs.fullCalendar.getApi().currentData.dateProfile
                    .currentRange.start;
                let nextDate = new Date(
                  rangeStart.getFullYear(),
                  rangeStart.getMonth(),
                  rangeStart.getDate()
                );
                nextDate.setDate(nextDate.getDate() + 7);
                let nextDateFormat = `${nextDate.getFullYear()}-${
                  nextDate.getMonth() + 1
                }-${nextDate.getDate()}T00:00:00`;
                _self.updateScheduleAvailability(nextDateFormat, nextDate);
                return;
              }

              let dataDate =
                _self.$refs.fullCalendar.getApi().currentData.dateProfile
                  .currentRange.end;
              let date = new Date(
                dataDate.getFullYear(),
                dataDate.getMonth(),
                dataDate.getDate()
              );
              date.setDate(date.getDate() + 7);
              let dateFormat = `${date.getFullYear()}-${
                date.getMonth() + 1
              }-${date.getDate()}T00:00:00`;

              _self.updateSchedule(dateFormat, true);
            },
          },
        },
        //headerToolbar: getCalendarHeaderToolbar(true),
        headerToolbar: false,
        buttonText: {
          today: this.$t("reusables.today"),
        },
        titleFormat: function (date) {
          return getCalendarTitle(date.date, this.lang);
        },
        height: "auto",
        allDaySlot: false,
        viewDidMount: (view) => {
          let GMT = getHoursByTimeZoneName(
            this.$moment,
            this.$store.state.user.timeZoneName
          );
          view.el.querySelector(".fc-timegrid-axis-frame").innerHTML = GMT;
          view.el
            .querySelector(".fc-timegrid-axis-frame")
            .addEventListener("click", () => {
              if (!this.flagEditSchedule) {
                this.$bvModal.show("modal-change-time-zone");
              }
            });
        },
        initialView: "timeGridWeek",
        dayHeaderContent: (args) => {
          return getCalendarHeaderFormat(
            this.$moment,
            args.date,
            this.lang,
            this.formatDay
          );
        },
        eventTimeFormat: getCalendarEventTimeFormat(),
        editable: true,
        selectable: true,
        scrollTimeReset: false,
        selectMirror: true,
        dayMaxEvents: true,
        weekends: true,
        eventResizableFromStart: false,
        select: this.handleDateSelect,
        selectAllow: this.handleSelecAllow,
        eventChange: this.handleEvents,
      },
      flagPageLoaded: false,
      getFormatDateComplete: getFormatDateComplete,
      openLinkClass: openLinkClass,
      showAlertModal: false,
      showSpinnerSave: false,
      TYPE_SCHEDULE: Constants.TYPE_SCHEDULE,
      //typeScheduleTeacher: {'TeacherSchedule': 1, 'StudentSchedule': 2}
      flagCancelClass: false,
      flagNoCurrentSchedule: false,
    };
  },
  computed: {
    events() {
      return this.calendarOptions.events;
    },
  },
  watch: {
    events: function (val) {
      this.calendarOptions.events.forEach((element) => {
        if (element.flagUpdate) {
          element.editable = this.flagEditSchedule;
        }
      });
    },
  },
  async created() {
    await this.getScheduleAvailabilityConfigured();
    _self = this;
    //this.habilitarCalendar();
  },
  mounted() {
    //this.$bvModal.show("reject-student-schedule");
    this.$root.$on("updateTeacherSchedule", (value) => {
      this.RenderAgainSchedule();
    });
    this.loadExpiryReminders();
  },
  validations: {
    dataClass: {
      linkClass: {
        required,
        url,
      },
    },
  },
  methods: {
    loadExpiryReminders() {
      let self = this;
      baseInstanceAxios
        .get(`${this.apiURL}/resources/Groups/GetExpiringPlanReminders?Id=${this.$store.state.user.personTeacherId}&IsTeacher=true&LeadDays=30`)
        .then((resp) => {
          self.expiryReminders = (resp && resp.data && resp.data.list) ? resp.data.list : [];
          if (self.$refs.modalExpiry) { self.$refs.modalExpiry.show(self.expiryReminders); }
        })
        .catch(() => {});
    },
    expiryRemaining(r) {
      let rem = (r.duration || 0) - (r.totalHoursSchedule || 0);
      return rem > 0 ? Math.round(rem * 100) / 100 : 0;
    },
    expiryReminderText(r) {
      let en = this.$i18n.locale === "en";
      let label = r.name ? " (" + r.name + ")" : "";
      return en
        ? "Reminder: package" + label + " expires on " + r.strExpirationDate + " with " + this.expiryRemaining(r) + " unscheduled hour(s). Please coordinate to schedule them before it expires."
        : "Recordatorio: el paquete" + label + " vence el " + r.strExpirationDate + " con " + this.expiryRemaining(r) + " hora(s) sin agendar. Coordina para agendarlas antes del vencimiento.";
    },
    handleHideModal() {
      this.dataClass.linkClass = "";
      this.$v.$reset();
    },
    idValueSelectClassNameSelected(event) {
      this.classNameSelected = event;
    },
    validationURLClass: validationMessage(formLinkClass),
    handleDateSelect: function (selectInfo) {
      selectInfo.title = this.$t("reusables.unavailable");

      let _eventItemMerge = ValidarMergeHorarios(
        this.calendarOptions.events,
        selectInfo.startStr,
        selectInfo.endStr,
        this.$moment
      );

      if (Object.keys(_eventItemMerge).length == 0) {
        //si NO hay merge

        this.calendarOptions.events.push({
          idx: this.getEventIdx(),
          id: createEventId(),
          start: selectInfo.startStr,
          description: "",
          end: selectInfo.endStr,
          title: !this.flagScheduleAvailability
            ? this.$t("reusables.available")
            : this.$t("reusables.unavailable"),
          color: !this.flagScheduleAvailability ? "#000000" : "", //Consultar
          editable: true,
          flagUpdate: true,
        });
      }

      this.$refs.fullCalendar.getApi().unselect();
    },
    getEventIdx: function () {
      let dataTmp = this.calendarOptions.events;
      let idx = 0;

      let ultId =
        dataTmp.length == 0 ? 1 * -1000 : dataTmp[dataTmp.length - 1].id;
      ultId = ultId == null ? 0 : ultId;
      idx = ultId > 0 ? dataTmp.length * -1000 : ultId - 1000;

      return idx;
    },
    toggleEditScheduleUnavailability: function (val) {
      this.flagEditSchedule = val;

      if (this.flagScheduleStudents && val) {
        this.calendarOptions.events = [];
        this.$refs.fullCalendar.getApi().today();
        this.$refs.fullCalendar
          .getApi()
          .setOption("headerToolbar", getCalendarHeaderToolbar(true));
        this.flagScheduleStudents = false;
        this.editScheduleDate = null;
        this.getScheduleConsolidated(true);
        this.formatDay = "";
      } else {
        this.$refs.fullCalendar
          .getApi()
          .setOption("headerToolbar", getCalendarHeaderToolbar(true));
        this.calendarOptions.events = [];
        this.flagScheduleStudents = true;
        if (this.flagCancelClass) {
          this.flagCancelClass = false;

          let dataDate =
            this.$refs.fullCalendar.getApi().currentData.dateProfile
              .currentRange.end;
          let date = new Date(
            dataDate.getFullYear(),
            dataDate.getMonth(),
            dataDate.getDate()
          );
          let dateFormat = `${date.getFullYear()}-${
            date.getMonth() + 1
          }-${date.getDate()}T00:00:00`;
          this.updateSchedule(dateFormat, null);
        } else {
          this.GetDashboardScheduleByTeacher();
        }

        this.formatDay = "DD";
      }

      this.calendarOptions.selectable = val;

      this.calendarOptions.events.forEach((element) => {
        if (element.flagUpdate) {
          element.editable = val;
        }
      });
    },
    handleEvents: function (arg) {
      let starDate = new Date(arg.event.start);
      let endDate = new Date(arg.event.end);
      let limitDate = new Date(
        starDate.getFullYear(),
        starDate.getMonth(),
        starDate.getDate() + 1,
        0,
        0,
        0
      );

      let _eventItemMerge = ValidarMergeHorarios(
        this.calendarOptions.events,
        arg.event.start,
        arg.event.end,
        this.$moment
      );

      if (endDate.getTime() <= limitDate.getTime()) {
        let element = this.calendarOptions.events.find(
          (x) => arg.event.id == x.id
        );
        this.removeEvent({ id: element.id });

        if (Object.keys(_eventItemMerge).length == 0) {
          //si NO hay merge
          this.calendarOptions.events.push({
            ...element,
            start: arg.event.start,
            end: arg.event.end,
          });
        }
      } else {
        arg.revert();
      }
    },
    handleSelecAllow(selectInfo) {
      let num = this.ObtenerRangoFecha(selectInfo.startStr, selectInfo.endStr);

      if (num > 0) {
        return false;
      }

      let starDate = new Date(selectInfo.start);
      let endDate = new Date(selectInfo.end);
      let limitDate = new Date(
        starDate.getFullYear(),
        starDate.getMonth(),
        starDate.getDate() + 1,
        0,
        0,
        0
      );

      return endDate.getTime() <= limitDate.getTime();

      //return true;
    },
    removeEvent: function (event) {
      this.calendarOptions.events = this.calendarOptions.events.filter(
        (x) => x.id != event.id
      );
    },
    toggleFlagEdit: function (value) {
      this.flagEditLink = value;
      this.dataClass.linkClass = this.linkClass;
    },
    getScheduleAvailabilityConfigured: function () {
      this.flagPageLoaded = true;
      baseInstanceAxios
        .get(
          this.apiURL +
            `/resources/PersonsTeachers/ScheduleAvailabilityConfigured?PersonTeacherId=${this.$store.state.user.personTeacherId}`
        )
        .then((response) => {
          if (response.data != null) {
            this.flagScheduleAvailability = response.data.return;

            if (this.flagScheduleAvailability) {
              this.calendarOptions.selectable = false;
              this.GetDashboardScheduleByTeacher();
            } else {
              this.formatDay = "";
              this.calendarOptions.events = [];

              this.flagPageLoaded = false;
              this.flagEditSchedule = true;
            }
            this.showLoadingCalendar = false;
          }
        })
        .catch((err) => {
          console.log("err : ", err);
          this.flagPageLoaded = false;
        });
    },
    saveScheduleUnavailability: function () {
      this.isLoading = true;
      let json = [];

      if (!this.flagScheduleAvailability) {
        //Guardado por primera Vez => Escoge fechas disponibles
        const arrDays = [0, 1, 2, 3, 4, 5, 6];

        let calendarOptions = this.calendarOptions.events.map((x) => {
          if (x.editable) {
            return {
              startDateAvailability: new Date(x.start),
              endDateAvailability: new Date(x.end),
            };
          }
        });

        let calendarOptionsDays = [
          ...new Set(
            calendarOptions.map((x) => x.startDateAvailability.getDay())
          ),
        ];
        json = arrDays
          .filter((x) => !calendarOptionsDays.includes(x))
          .map((w) => {
            let d = w - 1;
            d = d == -1 ? 6 : d;
            return `${d};0:00;23:59`;
          });
        //debugger;
        let groupCalendarOptionsByDay = calendarOptionsDays.map(function (
          item
        ) {
          return calendarOptions.filter(
            (x) => x.startDateAvailability.getDay() == item
          );
        });

        groupCalendarOptionsByDay.forEach((elements) => {
          elements.sort(function (a, b) {
            if (a.startDateAvailability > b.startDateAvailability) {
              return 1;
            }
            if (a.startDateAvailability < b.startDateAvailability) {
              return -1;
            }

            return 0;
          });

          for (
            let i = 0, l = elements.length - 1, s = elements.length;
            i < s;
            i++
          ) {
            const { startDateAvailability, endDateAvailability } = elements[i];
            let initHour,
              endHour,
              date = startDateAvailability.getDay() - 1;
            date = date == -1 ? 6 : date;

            if (
              startDateAvailability.getDate() !=
                endDateAvailability.getDate() &&
              startDateAvailability.getHours() == 0
            ) {
              continue;
            }
            if (s == 1) {
              if (
                startDateAvailability.getHours() == 0 &&
                startDateAvailability.getMinutes() == 0
              ) {
                initHour = `${endDateAvailability.getHours()}:${
                  (endDateAvailability.getMinutes() < 10 ? "0" : "") +
                  endDateAvailability.getMinutes()
                }`;
                json.push(`${date};${initHour};23:59`);
              } else if (
                startDateAvailability.getDate() != endDateAvailability.getDate()
              ) {
                //=> (endDateAvailability.getHours() == 0 && endDateAvailability.getMinutes() == 0)
                endHour = `${startDateAvailability.getHours()}:${
                  (startDateAvailability.getMinutes() < 10 ? "0" : "") +
                  startDateAvailability.getMinutes()
                }`;
                json.push(`${date};0:00;${endHour}`);
              } else {
                endHour = `${startDateAvailability.getHours()}:${
                  (startDateAvailability.getMinutes() < 10 ? "0" : "") +
                  startDateAvailability.getMinutes()
                }`;
                json.push(`${date};0:00;${endHour}`);

                initHour = `${endDateAvailability.getHours()}:${
                  (endDateAvailability.getMinutes() < 10 ? "0" : "") +
                  endDateAvailability.getMinutes()
                }`;
                json.push(`${date};${initHour};23:59`);
              }
            } else {
              if (
                startDateAvailability.getHours() == 0 &&
                startDateAvailability.getMinutes() == 0
              ) {
                initHour = `${endDateAvailability.getHours()}:${
                  (endDateAvailability.getMinutes() < 10 ? "0" : "") +
                  endDateAvailability.getMinutes()
                }`;
                let nextE = elements[i + 1];
                endHour = `${nextE.startDateAvailability.getHours()}:${
                  (nextE.startDateAvailability.getMinutes() < 10 ? "0" : "") +
                  nextE.startDateAvailability.getMinutes()
                }`;
                if (initHour != endHour)
                  json.push(`${date};${initHour};${endHour}`);
              } else if (
                startDateAvailability.getDate() != endDateAvailability.getDate()
              ) {
                continue;
              } else {
                if (i == 0) {
                  endHour = `${startDateAvailability.getHours()}:${
                    (startDateAvailability.getMinutes() < 10 ? "0" : "") +
                    startDateAvailability.getMinutes()
                  }`;
                  json.push(`${date};0:00;${endHour}`);

                  let nextE = elements[i + 1];
                  initHour = `${endDateAvailability.getHours()}:${
                    (endDateAvailability.getMinutes() < 10 ? "0" : "") +
                    endDateAvailability.getMinutes()
                  }`;
                  endHour = `${nextE.startDateAvailability.getHours()}:${
                    (nextE.startDateAvailability.getMinutes() < 10 ? "0" : "") +
                    nextE.startDateAvailability.getMinutes()
                  }`;
                  if (initHour != endHour)
                    json.push(`${date};${initHour};${endHour}`);
                } else if (i == l) {
                  initHour = `${endDateAvailability.getHours()}:${
                    (endDateAvailability.getMinutes() < 10 ? "0" : "") +
                    endDateAvailability.getMinutes()
                  }`;
                  json.push(`${date};${initHour};23:59`);
                } else {
                  let nextE = elements[i + 1];
                  initHour = `${endDateAvailability.getHours()}:${
                    (endDateAvailability.getMinutes() < 10 ? "0" : "") +
                    endDateAvailability.getMinutes()
                  }`;
                  endHour = `${nextE.startDateAvailability.getHours()}:${
                    (nextE.startDateAvailability.getMinutes() < 10 ? "0" : "") +
                    nextE.startDateAvailability.getMinutes()
                  }`;
                  if (initHour != endHour)
                    json.push(`${date};${initHour};${endHour}`);
                }
              }
            }
          }
        });
      } else {
        //Guardado por segunda vez
        let calendarOptions = this.calendarOptions.events.filter(
          (currentValue) => {
            return currentValue.editable;
          }
        );

        json = calendarOptions.map(function (element) {
          if (element.editable) {
            let startDateUnavailability = new Date(element.start);
            let endDateUnavailability = new Date(element.end);

            let date = startDateUnavailability.getDay() - 1; //LUNES = 0, MARTES = 1, ... DOMINGO = 6
            date = date == -1 ? 6 : date; //si es domingo, estara en -1, entonces pasarlo a 6

            let initHour = `${startDateUnavailability.getHours()}:${
              (startDateUnavailability.getMinutes() < 10 ? "0" : "") +
              startDateUnavailability.getMinutes()
            }`;
            let endHour = `${endDateUnavailability.getHours()}:${
              (endDateUnavailability.getMinutes() < 10 ? "0" : "") +
              endDateUnavailability.getMinutes()
            }`;
            //CUANDO LA HORA DE FIN ES CERO, DEVOLVER 24
            endHour = endHour == "0:00" ? "23:59" : endHour;
            return `${date};${initHour};${endHour}`;
          }
        });
      }

      let data = {
        Id: this.$store.state.user.personTeacherId,
        Person: {
          Email: this.$store.state.user.email,
          TimeZoneName: this.$store.state.user.timeZoneName,
        },
        ScheduleStr: json.join("|"),
      };

      baseInstanceAxios
        .post(
          this.apiURL + "/resources/PersonsTeachers/saveScheduleUnavailability",
          data
        )
        .then((response) => {
          this.isLoading = false;
          //pintar HORARIO,
          this.flagScheduleAvailability = true;
          //this.flagEditSchedule = false;
          this.toggleEditScheduleUnavailability(false);
        })
        .catch((err) => {
          console.log("err : ", err);
          this.isLoading = false;
        });
    },
    updateScheduleAvailability: function (dateFormat, dateObj) {
      this.editScheduleDate = dateFormat;
      // No merge here: the auto-merge/dedup step is meant for right after an edit is
      // submitted (combining just-adjusted blocks visually); browsing to a different
      // week is a plain fresh view of that week's data.
      this.getScheduleConsolidated(false, dateFormat);
      // Navigate the calendar's own view to the exact date we just fetched data for
      // (rather than FullCalendar's native next()/prev(), whose own week-advance logic
      // does not necessarily land on the same date the data query used).
      this.$refs.fullCalendar.getApi().gotoDate(dateObj || new Date());
    },
    getScheduleConsolidated: function (merge, date) {
      //console.log("getScheduleConsolidated: " + merge);
      this.showLoadingCalendar = true;
      this.calendarOptions.events = [];
      baseInstanceAxios
        .get(
          this.apiURL +
            `/resources/PersonsTeachers/GetTeacherScheduleConsolidatedAvailability?idTeacher=${
              this.$store.state.user.personTeacherId
            }&flagPlanTest=${null}&timeZoneName=${
              this.$store.state.user.timeZoneName
            }` +
            (date ? `&date=${date}` : "")
        )
        .then((response) => {
          if (
            response.data != null &&
            response.data.list != null &&
            response.data.list.length > 0
          ) {
            response.data.list.forEach((element) => {
              let titleName = element.className;
              if (element.className == "No Disponible") {
                titleName = this.$t("reusables.unavailable");
              }
              let className = this.$t("reusables.class");

              this.calendarOptions.events.push({
                idx: this.getEventIdx(),
                id: createEventId(),
                start: element.startDate,
                description: "",
                _end: element.endDate,
                end:
                  this.$moment(element.endDate).format("HH:mm") == "23:59"
                    ? this.$moment(element.endDate)
                        .add(1, "minutes")
                        .format("YYYY-MM-DDTHH:mm:ss")
                    : element.endDate,
                title:
                  titleName +
                    (element.flagPlanTest
                      ? " | " + this.$t("reusables.test-class")
                      : "") || className,
                //editable: element.flagUpdate,
                editable: false,
                color: element.flagUpdate
                  ? Constants.CALENDAR_STATUS.UNAVAILABLE.COLOR
                  : Constants.CALENDAR_STATUS.CONFIRM.COLOR,
                flagUpdate: element.flagUpdate,
              });
            });

            //merge = false;
            if (merge) {
              let elementsRemover = [];
              let calendarStudents = this.calendarOptions.events.filter(
                (currentValue) => {
                  return !currentValue.flagUpdate;
                }
              );
              calendarStudents.forEach((element, index) => {
                var flagRpta = this.AutoMergeHorarios(
                  calendarStudents,
                  element.start,
                  element.end,
                  this.$moment
                );

                if (!flagRpta) {
                  elementsRemover.push(index);
                }
              });

              //ELIMINAR ELEMENTOS

              if (elementsRemover.length != 0) {
                let elementsRemoverReversed = elementsRemover.reverse();
                elementsRemoverReversed.forEach((idx) => {
                  this.calendarOptions.events.splice(idx, 1);
                });
              }
            }

            this.flagPageLoaded = false;
            this.showLoadingCalendar = false;
          } else {
            this.formatDay = "";
            this.calendarOptions.events = [];
            this.flagPageLoaded = false;
            this.showLoadingCalendar = false;
          }
        })
        .catch((err) => {
          console.log("err : ", err);
        });
    },
    GetDashboardScheduleByTeacher: function () {
      this.showLoadingCalendar = true;
      this.calendarOptions.events = [];
      baseInstanceAxios
        .get(
          this.apiURL +
            `/resources/PersonsTeachers/GetDashboardScheduleByTeacher?PersonTeacherId=${this.$store.state.user.personTeacherId}&timeZoneName=${this.$store.state.user.timeZoneName}`
        )
        .then((response) => {
          if (response.data != null && response.data.entity != null) {
            //console.log("response.data.entity: ",response.data.entity)
            //VALIDAR SI TIENE ALUMNOS O NO
            //this.flagScheduleStudents = response.data.entity.listStudent.length != 0;
            this.flagScheduleStudents = response.data.entity.flagClasses;
            //SI TIENE CLASES, ENTONCES HAY QUE MOSTRAR EL HORARIO DE LA SEMANA
            //console.log(" this.flagScheduleStudents : ", this.flagScheduleStudents)
            if (response.data.entity.flagClasses) {
              //console.log("response.data.entity.scheduleDetail: ",response.data.entity.scheduleDetail)
              //let arrayHours = convertToUserTimeCalendarEvents(response.data.entity.scheduleDetail, this.$store.state.user.timeZoneName, this.$moment );
              if (response.data.entity.scheduleDetail.length > 0) {
                response.data.entity.scheduleDetail.forEach((element) => {
                  if (element.stateClass) {
                    element.stateClass.name =
                      horarioObtenerNameClaseENConsolidado(
                        element.stateClass.strValue
                      );
                  }

                  this.calendarOptions.events.push({
                    idx: this.getEventIdx(),
                    id: createEventId(),
                    start: element.startDate,
                    description: "",
                    _end: element.endDate,
                    //end: this.$moment(element.endDate).format("HH:mm") == '23:59' ? this.$moment(element.endDate).add(1, 'minutes').format("YYYY-MM-DDTHH:mm:ss") : element.endDate,
                    end:
                      this.$moment(element.endDate).format("mm") == "59"
                        ? this.$moment(element.endDate)
                            .add(1, "minutes")
                            .format("YYYY-MM-DDTHH:mm:ss")
                        : element.endDate,
                    //editable: element.flagUpdate,
                    flagUpdate: element.flagUpdate,
                    title:
                      element.typeOfSchedule == Constants.TYPE_SCHEDULE.TEACHER
                        ? this.$t("reusables.unavailable")
                        : element.className +
                            (element.flagPlanTest
                              ? " | " + this.$t("reusables.test-class")
                              : "") || this.$t("reusables.class"),
                    editable: false, //element.flagUpdate,
                    color:
                      element.typeOfSchedule == Constants.TYPE_SCHEDULE.TEACHER
                        ? Constants.CALENDAR_STATUS.UNAVAILABLE.COLOR
                        : horarioObtenerColorClaseConsolidado(
                            element.stateClass.strValue
                          ),
                    groupid: element.groupId,
                    typeOfSchedule: element.typeOfSchedule,
                    studentGroupName: element.className,
                    flagPlanTest: element.flagPlanTest,
                    subjectsName: element.subjectsName_EN,
                    stateClass: element.stateClass,
                    scheduleId: element.id,
                    linkClass: element.linkClass,
                    startEditable: element.flagUpdate,
                    flagGroup: element.flagGroup,
                  });
                });
                this.formatDay = "DD";
              } else {
                this.flagNoCurrentSchedule = true;
                this.formatDay = "";
                this.calendarOptions.events = [];
              }
              this.$refs.fullCalendar
                .getApi()
                .setOption("headerToolbar", getCalendarHeaderToolbar(true));
              this.nextClass = response.data.entity.teacherScheduleClass;

              let format_day = "MM/DD/YYYY"; //GH => Consultar si el formato cambia segun el idioma
              let format_time = "h:mm a";
              let format_time_validate = "YYYY-MM-DDTHH:mm:ss";
              if (this.nextClass) {
                this.nextClass.strStartDate_EN = getNextClassDate(
                  response.data.entity.teacherScheduleClass.startDate,
                  this.$store.state.user.timeZoneName,
                  this.$moment,
                  format_day
                );
                this.nextClass.strStartEndDate = getNextClassTime(
                  response.data.entity.teacherScheduleClass.startDate,
                  response.data.entity.teacherScheduleClass.endDate,
                  this.$store.state.user.timeZoneName,
                  this.$moment,
                  format_time
                );
                this.nextClass.startDate = convertTimeToUserTimeFormat(
                  response.data.entity.teacherScheduleClass.startDate,
                  this.$store.state.user.timeZoneName,
                  this.$moment,
                  format_time_validate
                );
                this.nextClass.endDate = convertTimeToUserTimeFormat(
                  response.data.entity.teacherScheduleClass.endDate,
                  this.$store.state.user.timeZoneName,
                  this.$moment,
                  format_time_validate
                );
              }

              this.listStudents = response.data.entity.listStudent;
              this.baseSchedule = this.calendarOptions.events;
              this.flagPageLoaded = false;
              this.showLoadingCalendar = false;
            } else {
              setTimeout(() => {
                this.$refs.fullCalendar
                  .getApi()
                  .setOption("headerToolbar", false);
              }, 500);

              this.formatDay = "";

              this.getScheduleConsolidated(this.flagEditSchedule);
            }
          }
        })
        .catch((err) => {
          console.log("err : ", err);
        });
    },
    cancelEditSchedule: function () {
      this.toggleEditScheduleUnavailability(false);
    },
    GetClass: function (idClass) {
      this.calendarOptions.events = this.baseSchedule.filter(
        (x) =>
          x.typeOfSchedule == Constants.TYPE_SCHEDULE.TEACHER ||
          idClass == 0 ||
          x.groupid == idClass
      );

      this.$forceUpdate();
    },
    async getDataClass(data) {
      let scheduleId = parseInt(data["_def"].extendedProps.scheduleId);
      if (scheduleId == 0 || this.flagEditSchedule) return;
      let format_time_validate = "YYYY-MM-DDTHH:mm:ss";
      this.dateStartValidate = null;
      this.dateEndValidate = null;
      this.messageResult = "";
      await baseInstanceAxios
        .get(
          `${this.apiURL}/resources/PersonsTeachers/GetDashboardScheduleTeacherScheduleById?ScheduleDetailId=${scheduleId}`
        )
        .then((response) => {
          let colorResquest = horarioObtenerColorClaseConsolidado(
            response.data.entity.stateClass.strValue
          );
          this.calendarOptions.events.filter(function (e) {
            if (e.scheduleId == data["_def"].extendedProps.scheduleId) {
              e.color = colorResquest;
              e.stateClass = response.data.entity.stateClass;

              //e.stateClass = response.data.entity.stateClass.value
              //e.stateClassName = response.data.entity.stateClass.name
            }
          });

          if (
            data["_def"].extendedProps.typeOfSchedule ==
            Constants.TYPE_SCHEDULE.STUDENT
          ) {
            let json = {
              startDate: data.startStr,
              endDate: data.endStr,
              idx: data["_def"].extendedProps.idx,
              id: data.id,
              //personTeacherId : data["_def"].extendedProps.personTeacherId,
              className: data["_def"].extendedProps.flagGroup
                ? this.$t("reusables.groupName", {
                    name: data["_def"].extendedProps.studentGroupName,
                  })
                : data["_def"].extendedProps.studentGroupName,
              subjectsName: data["_def"].extendedProps.subjectsName.replace(
                "|",
                "\n"
              ),
              stateClass: response.data.entity.stateClass,
              flagPlanTest: data["_def"].extendedProps.flagPlanTest,
              scheduleId: data["_def"].extendedProps.scheduleId,
              linkClass: data["_def"].extendedProps.linkClass,
              flagGroup: data["_def"].extendedProps.flagGroup,
              color: colorResquest,
            };
            this.linkClass = json.linkClass;
            this.infoClass = json;
            this.dataClass.linkClass = json.linkClass;
            //this.dateStartValidate = response.data.entity.startDate;
            //this.dateEndValidate = response.data.entity.endDate;
            this.dateStartValidate = convertTimeToUserTimeFormat(
              response.data.entity.startDate,
              this.$store.state.user.timeZoneName,
              this.$moment,
              format_time_validate
            );
            this.dateEndValidate = convertTimeToUserTimeFormat(
              response.data.entity.endDate,
              this.$store.state.user.timeZoneName,
              this.$moment,
              format_time_validate
            );
            this.toggleFlagEdit(
              !this.dataClass.linkClass && json.stateClass.value != "3"
            );
            this.$bvModal.show("modal-class-info");
          }
        });
    },
    cancelClass(scheduleId) {
      this.showSpinnerCancel = true;

      baseInstanceAxios
        .get(
          `${this.apiURL}/resources/PersonsTeachers/CancelScheduleClassByTeacher?personTeacherId=${this.$store.state.user.personTeacherId}&shceduleTeacherId=${scheduleId}&UserMail=${this.$store.state.user.email}`
        )
        .then((response) => {
          if (response.data != null && response.data.value != null) {
            if (response.data.value == 0) {
              this.message = this.$t("reusables.class-not-found");
              this.$bvToast.show("toast-equis-modal-calendar-class");
            } else if (response.data.value == 1) {
              this.message = this.$t("reusables.cannot-cancel-class-finished");
              this.$bvToast.show("toast-equis-modal-calendar-class");
            } else if (response.data.value > 1) {
              if (response.data.list != null && response.data.list.length > 0) {
                this.formatDay = "DD";
                this.nextClass = response.data.list[0];

                let format_day = "MM/DD/YYYY"; //GH => Consultar si el formato cambia segun el idioma
                let format_time = "h:mm a";
                let format_time_validate = "YYYY-MM-DDTHH:mm:ss";
                if (this.nextClass) {
                  this.nextClass.strStartDate_EN = getNextClassDate(
                    response.data.list[0].startDate,
                    this.$store.state.user.timeZoneName,
                    this.$moment,
                    format_day
                  );
                  this.nextClass.strStartEndDate = getNextClassTime(
                    response.data.list[0].startDate,
                    response.data.list[0].endDate,
                    this.$store.state.user.timeZoneName,
                    this.$moment,
                    format_time
                  );
                  this.nextClass.startDate = convertTimeToUserTimeFormat(
                    response.data.list[0].startDate,
                    this.$store.state.user.timeZoneName,
                    this.$moment,
                    format_time_validate
                  );
                  this.nextClass.endDate = convertTimeToUserTimeFormat(
                    response.data.list[0].endDate,
                    this.$store.state.user.timeZoneName,
                    this.$moment,
                    format_time_validate
                  );
                }
              } else {
                this.nextClass = null;
              }
              this.message = this.$t("reusables.successfully-canceled");
              this.$bvToast.show("toast-check-modal-calendar-class");
              this.flagCancelClass = true;
              this.cancelEditSchedule();
              this.$bvModal.hide("modal-class-info");
              this.$bvModal.hide("modal-schedule-cancel-teacher");
            }
          }

          this.showSpinnerCancel = false;
        })
        .catch((err) => {
          this.showSpinnerCancel = false;
          this.message = this.$t("reusables.error-canceling-class");
          this.$bvToast.show("toast-equis-modal-calendar-class");
        });
    },
    closeModalClassInfo() {
      this.showAlertModal = false;
      this.message = "";
      this.$bvModal.hide("modal-class-info");
    },
    updateSchedule(date, isNext, newDate = undefined) {
      this.showLoadingCalendar = true;
      console.log("date: ", date);
      console.log("isNext: ", isNext);

      //this.showLoadingCalendar = true;
      this.calendarOptions.events = [];
      baseInstanceAxios
        .get(
          `${this.apiURL}/resources/PersonsTeachers/GetDashboardScheduleWithDateByTeacher?PersonTeacherId=${this.$store.state.user.personTeacherId}&date=${date}&timeZoneName=${this.$store.state.user.timeZoneName}`
        )
        .then((response) => {
          if (response.data != null && response.data.entity != null) {
            //console.log("response.data.entity.scheduleDetail GetDashboardScheduleWithDateByTeacher : ",response.data.entity.scheduleDetail)
            //let arrayHours = convertToUserTimeCalendarEvents(response.data.entity.scheduleDetail, this.$store.state.user.timeZoneName, this.$moment );

            response.data.entity.scheduleDetail.forEach((element) => {
              if (element.stateClass) {
                element.stateClass.name = horarioObtenerNameClaseENConsolidado(
                  element.stateClass.strValue
                );
              }

              this.calendarOptions.events.push({
                idx: this.getEventIdx(),
                id: createEventId(),
                start: element.startDate,
                description: "",
                _end: element.endDate,
                end:
                  this.$moment(element.endDate).format("HH:mm") == "23:59"
                    ? this.$moment(element.endDate)
                        .add(1, "minutes")
                        .format("YYYY-MM-DDTHH:mm:ss")
                    : element.endDate,
                flagUpdate: element.flagUpdate,
                title:
                  element.typeOfSchedule == Constants.TYPE_SCHEDULE.TEACHER
                    ? this.$t("reusables.unavailable")
                    : element.className +
                        (element.flagPlanTest
                          ? " | " + this.$t("reusables.test-class")
                          : "") || "clase",
                editable: false,
                color:
                  element.typeOfSchedule == Constants.TYPE_SCHEDULE.TEACHER
                    ? Constants.CALENDAR_STATUS.UNAVAILABLE.COLOR
                    : horarioObtenerColorClaseConsolidado(
                        element.stateClass.strValue
                      ),
                groupid: element.groupId,
                typeOfSchedule: element.typeOfSchedule,
                studentGroupName: element.className,
                flagPlanTest: element.flagPlanTest,
                subjectsName: element.subjectsName_EN,
                stateClass: element.stateClass,
                scheduleId: element.id,
                linkClass: element.linkClass,
              });
            });

            this.baseSchedule = this.calendarOptions.events;
          }

          if (isNext) {
            this.$refs.fullCalendar.getApi().next();
          } else if (isNext == false) {
            this.$refs.fullCalendar.getApi().prev();
          } else {
            let calendarApi = this.$refs.fullCalendar.getApi();

            calendarApi.gotoDate(newDate || new Date());
          }

          //console.log("this.classNameSelected : ",this.classNameSelected )
          this.GetClass(this.classNameSelected);
          this.showLoadingCalendar = false;
        })
        .catch((err) => {
          console.log("err : ", err.response);
          this.showLoadingCalendar = false;
        });
    },
    saveLinkClass(scheduleId) {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      if (scheduleId) {
        let data = {
          //id: this.$store.state.user.personTeacherId,
          id: scheduleId,
          LinkClass: this.dataClass.linkClass,
          UserModified: this.$store.state.user.email,
        };

        baseInstanceAxios
          .post(
            `${this.apiURL}/resources/PersonsTeachers/SaveLinkScheduleClassTeacher`,
            data
          )
          .then(() => {
            this.linkClass = data.LinkClass;
            this.toggleFlagEdit(false);
            let objectIndex = this.calendarOptions.events.findIndex(
              (x) => x.id == this.infoClass.id
            );
            this.calendarOptions.events[objectIndex].linkClass = data.LinkClass;
          })
          .catch((err) => {
            console.log("err : ", err.response);
          });
      }
    },
    deleteLinkClass(scheduleId) {
      if (scheduleId) {
        let data = { id: scheduleId };

        baseInstanceAxios
          .post(
            `${this.apiURL}/resources/PersonsTeachers/DeleteLinkScheduleClassTeacher`,
            data
          )
          .then(() => {
            this.linkClass = "";
            this.dataClass.linkClass = "";
            let objectIndex = this.calendarOptions.events.findIndex(
              (x) => x.id == this.infoClass.id
            );
            this.calendarOptions.events[objectIndex].linkClass = null;
            this.toggleFlagEdit(true);
          })
          .catch((err) => {
            console.log("err : ", err.response);
          });
      }
    },
    openLinkClassLocal(linkClass, moment, startDate, endDate) {
      this.messageLinkClassResult = null;
      let result = openLinkClass(
        linkClass,
        moment,
        startDate,
        endDate,
        this.$store.state.user.timeZoneName
      );
      if (result != "") {
        this.messageLinkClassResult = result;
        this.$bvModal.show("modal-next-linkClass");
      }
    },
    viewClass(urlClass) {
      let result = openLinkClass(
        urlClass,
        this.$moment,
        this.dateStartValidate,
        this.dateEndValidate,
        this.$store.state.user.timeZoneName
      );
      if (result != "") {
        this.messageResult = result;
      }
    },
    ObtenerRangoFecha(StartDate, EndDate) {
      var result = this.calendarOptions.events.filter(function (e) {
        return (
          (!(new Date(StartDate).getTime() == new Date(e.start).getTime()) &&
            new Date(StartDate).getTime() <= new Date(e.start).getTime() &&
            new Date(EndDate).getTime() >= new Date(e.end).getTime()) ||
          (new Date(StartDate).getTime() >= new Date(e.start).getTime() &&
            new Date(StartDate).getTime() < new Date(e.end).getTime() &&
            new Date(EndDate).getTime() >= new Date(e.end).getTime()) ||
          (new Date(StartDate).getTime() <= new Date(e.start).getTime() &&
            new Date(EndDate).getTime() > new Date(e.start).getTime() &&
            new Date(EndDate).getTime() <= new Date(e.end).getTime()) ||
          (new Date(StartDate).getTime() == new Date(e.start).getTime() &&
            new Date(EndDate).getTime() == new Date(e.end).getTime()) ||
          (new Date(StartDate).getTime() >= new Date(e.start).getTime() &&
            new Date(EndDate).getTime() <= new Date(e.end).getTime())
        );
      });
      return result.length;
    },
    RenderAgainSchedule() {
      if (this.flagScheduleAvailability) {
        if (this.flagScheduleStudents) {
          //No Edición
          let strDate =
            this.$refs.fullCalendar.getApi().currentData.dateProfile
              .currentRange.end;
          let dateMoment = this.$moment(strDate);
          let dateFormat = dateMoment.format("yyyy-MM-DDT00:00:00");

          this.updateSchedule(dateFormat, null, dateMoment._d);
        } else {
          this.getScheduleConsolidated(false);
        }
      }
    },
    AutoMergeHorarios(listaHorarios, _fechaInicio, _fechaFin, moment) {
      let rpta = true;
      listaHorarios.every((eventItem) => {
        if (
          moment(_fechaInicio).format("YYYY-MM-DD HH:mm") ==
          moment(eventItem.end).format("YYYY-MM-DD HH:mm")
        ) {
          eventItem.end = moment(_fechaFin).format("YYYY-MM-DDTHH:mm:ss");

          rpta = false;
          return false;
        } else if (
          moment(_fechaFin).format("YYYY-MM-DD HH:mm") ==
          moment(eventItem.start).format("YYYY-MM-DD HH:mm")
        ) {
          eventItem.start = moment(_fechaInicio).format("YYYY-MM-DDTHH:mm:ss");

          rpta = false;
          return false;
        }
        return true;
      });

      return rpta;
    },
  },
};
</script>
<style>
.cursor-pointer {
  cursor: pointer;
}
.hide-background {
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.3s ease-in-out;
}

.modal-open {
  overflow: hidden !important; 
}
.push-down {
  margin-top: 100vh;
  transition: margin-bottom 0.3s ease-in-out;
}
</style>